import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  Renderer2,
} from '@angular/core';
import { ThemeService } from '../../services/theme.service';
import { LayoutService } from '../../services/layout.service';
import { TranslateService } from '@ngx-translate/core';
import { RoutePartsService } from '../../services/route-parts.service';
import {
  Router,
  NavigationEnd,
  ActivatedRoute,
  ActivatedRouteSnapshot,
} from '@angular/router';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { Agent } from '../../models/agent.model';
import { AgentProfileService } from '../../services/agent-profile.service';
import { environment } from '../../../../environments/environment';

@Component({
  selector: 'app-header-side',
  templateUrl: './header-side.template.html',
  styleUrls: ['./header-side.template.scss'],
})
export class HeaderSideComponent implements OnInit {
  @Input() notificPanel;
  @Input() filterPanel;
  @Input() notificationsCount;
  routeParts: any[] = [];
  routerEventSub: Subscription;
  currentLang = 'en';
  environmentBaseUrl = environment.urlDomain;
  public availableLangs = [
    {
      name: 'English',
      code: 'en',
    },
    {
      name: 'Spanish',
      code: 'es',
    },
  ];
  agentInfoSub: Subscription;
  pageTitle = '';
  public egretThemes;
  public layoutConf: any;
  public agentInfo: Agent;
  constructor(
    private themeService: ThemeService,
    private layout: LayoutService,
    public translate: TranslateService,
    private renderer: Renderer2,
    private routePartsService: RoutePartsService,
    private router: Router,
    private activeRoute: ActivatedRoute,
    private agentInfoService: AgentProfileService,
  ) {
    this.routeParts = this.routePartsService.generateRouteParts(
      this.activeRoute.snapshot,
    );
    this.routerEventSub = this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(routeChange => {
        this.routeParts = this.routePartsService.generateRouteParts(
          this.activeRoute.snapshot,
        );
        // generate url from parts
        this.routeParts.reverse().map((item, i) => {
          item.breadcrumb = this.parseText(item);
          item.breadcrumbHide = item.breadcrumbHide;
          item.urlSegments.forEach((urlSegment, j) => {
            if (j === 0) return (item.url = `${urlSegment.path}`);
            item.url += `/${urlSegment.path}`;
          });
          if (i === 0) {
            return item;
          }
          // prepend previous part to current part
          item.url = `${this.routeParts[i - 1].url}/${item.url}`;
          return item;
        });
      });
    this.agentInfoSub = this.agentInfoService.agentFetched.subscribe(val => {
      this.agentInfo = val;
    });
    // this.agentInfoService.getAgent().subscribe(data => {
    //   this.agentInfo = new Agent(data);
    //   this.agentInfoService.addAgentData(this.agentInfo);
    // });
  }
  ngOnInit() {
    this.egretThemes = this.themeService.egretThemes;
    this.layoutConf = this.layout.layoutConf;
    this.translate.use(this.currentLang);
  }

  ngOnDestroy() {
    if (this.routerEventSub) this.routerEventSub.unsubscribe();
    if (this.agentInfoSub) this.agentInfoSub.unsubscribe();
  }

  setLang(e) {
    this.translate.use(this.currentLang);
  }
  changeTheme(theme) {
    this.themeService.changeTheme(this.renderer, theme);
  }
  toggleNotific() {
    this.notificPanel.toggle();
  }
  toggleSidenav() {
    if (this.layoutConf.sidebarStyle === 'closed') {
      return this.layout.publishLayoutChange({
        sidebarStyle: 'full',
      });
    }
    this.layout.publishLayoutChange({
      sidebarStyle: 'closed',
    });
  }

  toggleCollapse() {
    // compact --> full
    if (this.layoutConf.sidebarStyle === 'compact') {
      return this.layout.publishLayoutChange(
        {
          sidebarStyle: 'full',
        },
        { transitionClass: true },
      );
    }

    // * --> compact
    this.layout.publishLayoutChange(
      {
        sidebarStyle: 'compact',
      },
      { transitionClass: true },
    );
  }
  parseText(part) {
    part.breadcrumb = part.breadcrumb.replace(/{{([^{}]*)}}/g, function (a, b) {
      var r = part.params[b];
      return typeof r === 'string' ? r : a;
    });
    return part.breadcrumb;
  }
  openCalendly() {
    (<any>window).Calendly.showPopupWidget(
      'https://calendly.com/mashvisor/demo/?utm_source=Mashboard&utm_medium=Mashboard&utm_campaign=Mashboard&utm_term=Mashboard',
    );
  }
  signOut() {
    this.agentInfoService.signOut();
    window.location.pathname = '';
  }
}
